// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthCompleted_wrapper__aPBtH"};